import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

/**
 * Deletes a style. Its texts keep the look they have and simply stop following
 * it, so removing a style never changes what prints.
 */
const removeTextStyleReducer = (state: DesignState, action: PayloadAction<string>) => {
  const { designData } = state;
  if (!designData?.textStyles) {
    return;
  }
  designData.textStyles = designData.textStyles.filter(({ id }) => id !== action.payload);
  if (!designData.textStyles.length) {
    delete designData.textStyles;
  }
  designData.spreads.forEach((spread) =>
    spread.pages.forEach((page) =>
      page.groups.media?.forEach((element) => {
        if (element.type === 'text' && element.extra.textStyleId === action.payload) {
          delete element.extra.textStyleId;
        }
      }),
    ),
  );
};

export default removeTextStyleReducer;
